// src/features/auth/Routes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import InfoscreenShowPage from './pages/InfoscreenShowPage';

export const ProtectedInfoscreensRoutes = () => (
  <>
    {/* Routes only showen when authendicated but no supporting ui (wrapped NullLayout) */}
    <Route path="/infoscreens/show" element={<InfoscreenShowPage />} />
  </>
);